<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">{{ location }}</h2>
      <span>|</span>
      <h2 class="title title-primary">
        {{ $t("lang.movement-entry.order_detail.page_title_line_1") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        {{ $t("lang.movement-entry.order_detail.page_title_line_2") }}
      </h3>
    </div>
    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">
        <bx-box
          dark
          color="outline"
          :title="$t('lang.movement-entry.order_detail.box_title_1')"
          class="col-12 col-md-6 col-lg-auto p-1"
        >
          <template slot="actions">
            <bx-order-status :status="status" dark></bx-order-status>
          </template>
          <div class="detail-titles">
            <div class="wrapper">
              <h4>
                Nº
                <strong>{{ id }}</strong>
              </h4>
              <h5>
                <strong>{{ name }}</strong>
              </h5>
            </div>
          </div>
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.movement-entry.order_detail.box_label_2')"
            :value="arrivalTime"
            font-size="xs"
          />
        </bx-box>

        <bx-box
          dark
          color="outline"
          class="col-6 col-md-4 col-lg-auto p-1 bx-box-adjustable"
        >
          <bx-value
            :label="$t('lang.movement-entry.order_detail.box_label_3')"
            :value="destinationWaitingTime"
            :valueColor="valueColor"
            font-size="xs"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-md-4 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.movement-entry.order_detail.box_label_4')"
            :value="
              `${orderData.destination_real_item_count} / ${orderData.item_count}`
            "
            font-size="xs"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-md-4 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.movement-entry.order_detail.box_label_5')"
            :value="
              `${orderData.destination_num_verified_boxes} / ${orderData.num_boxes}`
            "
            font-size="xs"
          />
        </bx-box>
      </div>
      <skeleton-boxes :boxes="5" v-else />
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
        <div class="row" style="margin: 8px">
          <bx-btn @click="$router.back()">{{
            $t("lang.messages.go_back")
          }}</bx-btn>
        </div>
        <div class="row">
          <div class="col-12">
            <bx-box
              :title="
                itemCount +
                  ' ' +
                  `${$t('lang.movement-entry.order_detail.table_title')}`
              "
              color="white"
              no-padding
              :loading="shouldLoading"
            >
              <template v-slot:default>
                <bx-table
                  :data="data"
                  :columns="columns"
                  paginated
                  v-if="!shouldLoading"
                  backendPagination
                  :currentPage="page"
                  :perPage="itemsPerPage"
                  :total="itemCount"
                  @update:currentPage="updatePage"
                >
                  <template slot-scope="props">
                    <bx-table-column>
                      <router-link
                        :to="
                          `/movements/entry/order/${id}/gtin/${props.row.itemType}/detail`
                        "
                        class="bx-link bx-link-bold"
                        >{{ props.row.gtin }}</router-link
                      >
                    </bx-table-column>
                    <bx-table-column>{{ props.row.quantity }}</bx-table-column>
                    <bx-table-column>{{
                      props.row.quantity_real
                    }}</bx-table-column>
                    <bx-table-column>{{ props.row.description }}</bx-table-column>
                  <bx-table-column>{{ props.row.section }}</bx-table-column>
                    <bx-table-column>{{
                      props.row.cloth_type
                    }}</bx-table-column>
                    <bx-table-column>{{ props.row.model }}</bx-table-column>
                    <bx-table-column>{{ props.row.color }}</bx-table-column>
                    <bx-table-column>{{ props.row.size }}</bx-table-column>
                    <bx-table-column v-if="props.row.ratingPercent > 100">
                      <bx-complementary-mini
                        :percent="100"
                      ></bx-complementary-mini>
                    </bx-table-column>
                    <bx-table-column v-if="props.row.ratingPercent <= 100">
                      <bx-complementary-mini
                        :percent="props.row.ratingPercent"
                      ></bx-complementary-mini>
                    </bx-table-column>
                  </template>
                </bx-table>
              </template>
            </bx-box>
          </div>
        </div>
        <v-row class="d-flex d-sm-none">
          <div
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="busy"
            infinite-scroll-distance="20"
            style="width: 100%"
          >
            <v-list width="100%">
              <v-list-item
                two-line
                v-for="(item, index) in dataList"
                :key="index"
                class="green lighten-5 ma-2 rounded-lg"
                ripple
                :to="
                  `/movements/entry/order/${id}/gtin/${item.itemType}/detail`
                "
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <div>
                      {{ item.gtin }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>{{
                    item.description
                  }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{
                    item.section
                  }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text-caption">{{
                    item.cloth_type
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-subtitle class="text-caption">
                    {{ item.quantity_real + "/" + item.quantity }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-caption">
                    {{ item.color }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-caption">
                    {{ item.model }}
                  </v-list-item-subtitle>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </v-row>
        <skeleton-table :columns="10" v-if="shouldLoading" />
      </div>
    </div>
  </div>
</template>

<script>
import BxTable from "../../../bx-components/BxTable";
import BxTableColumn from "../../../bx-components/BxTableColumn";
import BxBtn from "../../../bx-components/BxBtn";
import BxOrderStatus from "../../../bx-components/BxOrderStatus";
import moment from "moment";
import common from "@/utils/common";

export default {
  name: "movements-order-entry-detail",
  components: { BxOrderStatus, BxBtn, BxTableColumn, BxTable },
  mixins: [common],
  props: {
    id: {
      type: [Number, String]
    }
  },
  data() {
    return {
      shouldLoading: true,
      columns: [],
      data: [],
      dataList: [],
      orderData: {},
      arrivalTime: "",
      destinationWaitingTime: "",
      itemCount: "",
      name: "",
      status: 0,
      contents: [],
      reloadInterval: null,
      API_BASE: process.env.VUE_APP_API_BASE,
      itemsPerPage: process.env.VUE_APP_GTIN_PER_PAGE,
      page: 1,
      valueColor: "white"
    };
  },
  computed: {
    location() {
      return localStorage.getItem("location");
    }
  },
  methods: {
    loadMore() {
      if (
        !this.shouldLoading &&
        this.dataList.length &&
        this.dataList.length < this.itemCount &&
        this.isMobile
      ) {
        this.page++;
        this.getData(this.locationId);
      }
    },
    updatePage(p) {
      this.page = p;
      this.getData(this.locationId);
    },
    async getData() {
      try {
        if (this.isMobile) {
          this.shouldLoading = true;
        }
        let orderData = (this.orderData = await this.$api.morders.get(this.id));
        this.arrivalTime = this.orderData.arrival_date;
        this.status = this.orderData.destination_status;
        this.destinationWaitingTime = this.orderData.destination_waiting_time;
        this.name = this.orderData.order_name;

        let isAfter = moment().isAfter(orderData.estimated_arrival_date);
        if (isAfter) {
          this.valueColor = "red";
        }

        this.report = await this.$api.morders.report(this.id, {
          offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage
        });

        this.itemCount = this.report.count;
        this.data = this.report.results.map((item, key) => {
          return {
            gtin: item.gtin,
            itemType: item.item_type,
            quantity: item.theorical_quantity,
            quantity_real:
              item.destination_real_quantity !== null
                ? item.destination_real_quantity
                : 0,
            cloth_type: item.cloth_type,
            id: item.id,
            size: item.size,
            color: item.colour,
            model: item.model,
            description: item.description,
            section: item.section,
            ratingPercent:
              (item.destination_real_quantity / item.theorical_quantity) * 100
          };
        });

        if (this.isMobile) {
          this.dataList = this.dataList.concat(this.data);
        }

        this.columns = [
          {
            field: "gtin",
            label: this.$t("lang.movement-entry.order_detail.table_field_1")
          },
          {
            field: "quantity",
            label: this.$t("lang.movement-entry.order_detail.table_field_2")
          },
          {
            field: "real_quantity",
            label: this.$t("lang.movement-entry.order_detail.table_field_3")
          },
          {
            field: "description",
            label: this.$t("lang.movement-entry.order_detail.table_field_10")
          },
          {
            field: "section",
            label: this.$t("lang.movement-entry.order_detail.table_field_4")
          },
          {
            field: "itemtype",
            label: this.$t("lang.movement-entry.order_detail.table_field_5")
          },
          {
            field: "model",
            label: this.$t("lang.movement-entry.order_detail.table_field_6")
          },
          {
            field: "color",
            label: this.$t("lang.movement-entry.order_detail.table_field_7")
          },
          {
            field: "size",
            label: this.$t("lang.movement-entry.order_detail.table_field_8")
          },
          {
            field: "ratingPercent",
            label: this.$t("lang.movement-entry.order_detail.table_field_9"),
            width: 200
          }
        ];
      } catch (error) {
        console.error(error);
      } finally {
        this.shouldLoading = false;
      }
    },
    findByGTIN(myArray, gtin) {
      let res = null;
      myArray.forEach(item => {
        if (item.gtin === gtin) {
          res = item;
        }
      });
      return res;
    }
  },
  mounted() {
    if (!this.isMobile) {
      this.reloadInterval = setInterval(
        this.getData,
        process.env.VUE_APP_RELOAD_TIME
      );
    }
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  }
};
</script>
<style scoped>
@media screen and (max-width: 480px) {
  .bx-box-adjustable >>> .bx-box-content {
    min-height: 95px;
  }

  .bx-box-adjustable >>> .bx-value-value {
    margin-top: 10px;
  }
}

@media screen and (max-width: 411px) {
  .bx-box-adjustable >>> .bx-box-content {
    min-height: 79px;
  }

  .bx-box-adjustable >>> .bx-value-value {
    margin-top: 0px;
  }
}

@media screen and (max-width: 375px) {
  .bx-box-adjustable >>> .bx-box-content {
    min-height: 91px;
  }

  .bx-box-adjustable >>> .bx-value-value {
    margin-top: 10px;
  }
}
</style>
